import moment from "moment";

import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

import { ArrowRightIcon, BuildingIcon, DateIcon, FileTextIcon, PlusIcon, ResultIconTrendingUp, SparklesIcon } from '../../../shared/icons/Icons';
import { getApi } from "../../../shared/services/apiHelper";
import { projectsList, overviewData } from "../../../shared/settings/apiConfig";
import { DASHBOARD_METRICS } from "../../../shared/utils/constants";
import { formatCurrency } from "../../../shared/utils/formatCurrency";

import './Dashboard.scss';

const Dashboard = (props) => {

    const [metrics, setMetrics] = useState(DASHBOARD_METRICS);
    const [projectActivity, setProjectActivity] = useState([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        Promise.all([getProjectActivityApi(), getDashboardMetrics()]).then(responses => {
            setLoading(false);
            const activityResponse = responses[0];
            const metricsResponse = responses[1];

            if (metricsResponse) {
                setMetrics(prevState => {
                    return prevState.map(metric => {
                        const key = metric.key;
                        const value = metricsResponse[key];
                        return { ...metric, value: value !== undefined ? value : metric.value };
                    });
                });
            }

            setProjectActivity(activityResponse.data);
        }).catch(error => {
            console.log(error);
            setLoading(false);
        });
    }, []);

    const getProjectActivityApi = () => {
        return new Promise((resolve, reject) => {
            getApi(projectsList).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    };

    const getDashboardMetrics = () => {
        return getApi(overviewData)
            .then(response => response.data)
            .catch(error => {
                console.log("Dashboard metrics fetch failed:", error);
                return null;
            });
    };
    
    const viewAllOnClick = () => {
        props.history.push('/projects');
    };

    const quickLinkOnClick = (path) => {
        if ( path ) {
            props.history.push(path);
        }
    };

    const navigateToDetailProject = (project) => {
        // Match the routing logic from Datatable - check status to determine destination
        // Completed projects go to detail/read-only page, others go to edit page
        if (project.status?.toLowerCase() === "completed") {
            props.history.push(`/projects/${project.id}`);
        } else {
            props.history.push(`/projects/edit/${project.id}`);
        }
    }

    return (
        <div className="dashboard-container animate-fade-in auto">
             <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h3 className="content-label">Dashboard</h3>
                                <p className='content-sub-label'>Manage all your construction projects</p>
                            </div>
                            
                        </div>
            <div className="metrics">
                {
                    metrics.map((metric, index) => (
                        <div className="metric-card-view d-flex gap-3 flex-grow-1" key={"metric-" + index}>
                            <div className={`metric-icon ${metric.className}`}>
                                <metric.icon />
                            </div>
                            <div className="content">
                                <div className="fw-bold text-gray text-n">{metric.label}</div>
                                <div className="font-weight-bold text-3l">
                                    {metric.key === "totalestimatedvalue" ? formatCurrency(metric.value) : (metric.value || '0')}
                                </div>
                                <div className="description">{metric.label === "Completed" ? <><ResultIconTrendingUp color="rgb(5 150 105)" /> {metric.description}</> : metric.description}</div>
                            </div>
                        </div>
                    ))
                }
            </div>

            <div className='welcome-card'>
                <div className="d-flex align-items-center gap-3">
                    <div className="greetings">
                        <SparklesIcon size={24} />
                    </div>

                    <div className="d-flex flex-column ">
                        <h2 className="welcome-label text-2l">Ready to estimate a new project?</h2>
                        <p className="quick-note">Upload your construction diagram and get AI-powered estimates in minutes.</p>
                    </div>
                </div>

                <div className="estimate-btns">
                    <Button variant="secondary" onClick={() => quickLinkOnClick('/projects/select-type')}>
                        <PlusIcon />
                        Start New Estimation
                    </Button>
                </div>
            </div>

            <div className="d-flex justify-content-between header">
                <div>
                    <div className="text-2l font-weight-bold">Recent Projects</div>
                </div>
                <div className="view-all" role="button" onClick={viewAllOnClick}>
                    View All
                    <ArrowRightIcon />
                </div>
            </div>

            <div className="recent-activity"> 
                <div className="activity-list">
                    {
                        loading ?
                            <div className="d-flex align-items-center justify-content-center" style={{ height: '50vh' }}>
                                <img className='loader-icon' src={`${process.env.PUBLIC_URL}/static/images/loader.svg`} alt="loader" />
                            </div> :
                        projectActivity.length === 0 ?  
                            <div className="d-flex flex-column align-items-center justify-content-center gap-3 activity-card p-5">
                                <div className="file-icon">
                                   <FileTextIcon color={"#6b4ba1"} size={35} />
                                </div>
                                <div className="text-1l">No projects yet</div>
                                <span className="text-muted">Upload your first construction diagram to get started</span>
                                <div  className="btn btn-solid-blue fw-bold" onClick={() => quickLinkOnClick('/projects/select-type')}>
                                    <PlusIcon />
                                    Create First Project
                                </div>
                                
                            </div> : 
                            projectActivity.map((activity, index) => (
                                <div className="activity-card" key={"activity-" + index} onClick={() => {navigateToDetailProject(activity)}}>                                    
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="build-icon"><BuildingIcon color="white" /></div>
                                        <div className="d-flex flex-column justify-content-center gap-2 text-default-label">
                                            <div className="fw-bold text-l">{activity.name}</div>
                                            <div className="d-flex align-items-center gap-3 text-muted fw-bold text-n"><DateIcon color="rgb(33 37 41 / 75%)" />{moment.utc(activity.updated_at).tz("Asia/Kolkata").format('MM/DD/YYYY')}</div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between gap-3" >
                                        <div className={activity.status === "Completed" ? "status-badge-green" : "status-badge-purple" }>{activity.status || '---'}</div>
                                        <ArrowRightIcon color="#9ca3af" />
                                    </div>
                                </div>
                            ))
                    }
                </div>
            </div>
        </div>
    );
};

export default Dashboard;